export const techniques = [
  {
    id: 1,
    name: 'Heel Hook',
    type: 'Submission',
    position: 'Ashi Garami',
    difficulty: 'Advanced',
    description: 'A powerful leg lock submission that attacks the heel and ankle. Control the leg with inside ashi garami position, secure the heel, and apply rotational pressure.',
    keyPoints: [
      'Maintain tight inside control with legs',
      'Keep heel close to chest',
      'Rotate entire body, not just arms',
      'Control opponents free leg'
    ],
    commonMistakes: [
      'Losing inside position control',
      'Using only arm strength',
      'Not controlling the free leg',
      'Incorrect angle of attack'
    ]
  },
  {
    id: 2,
    name: 'Kimura from Guard',
    type: 'Submission',
    position: 'Guard',
    difficulty: 'Intermediate',
    description: 'A shoulder lock submission from closed or open guard. Isolate the arm, secure the figure-four grip, and apply pressure by pulling the wrist towards the opponent\'s back.',
    keyPoints: [
      'Control the wrist with both hands',
      'Keep elbows tight',
      'Use hip movement to create angle',
      'Break posture first'
    ],
    commonMistakes: [
      'Losing wrist control',
      'Not creating proper angle',
      'Forcing the submission too early',
      'Allowing opponent to posture up'
    ]
  },
  {
    id: 3,
    name: 'Butterfly Sweep',
    type: 'Sweep',
    position: 'Guard',
    difficulty: 'Beginner',
    description: 'A fundamental sweep from butterfly guard. Use your hooks to elevate and off-balance your opponent while pulling them over you.',
    keyPoints: [
      'Get underhooks or control sleeves',
      'Stay close to opponent',
      'Lift with legs and pull with arms simultaneously',
      'Commit to the direction'
    ],
    commonMistakes: [
      'Being too far from opponent',
      'Not using hooks effectively',
      'Poor timing',
      'Not committing to the sweep'
    ]
  },
  {
    id: 4,
    name: 'Rear Naked Choke',
    type: 'Submission',
    position: 'Back Control',
    difficulty: 'Beginner',
    description: 'The most fundamental choke from back control. Secure one arm under the chin, lock hands, and apply pressure by squeezing and expanding your chest.',
    keyPoints: [
      'Get the choking arm deep under chin',
      'Lock hands properly (palm to palm or gable grip)',
      'Use legs to control hips',
      'Expand chest while squeezing'
    ],
    commonMistakes: [
      'Arm across face instead of under chin',
      'Weak hand grip',
      'Not controlling with legs',
      'Using only arm strength'
    ]
  },
  {
    id: 5,
    name: 'Arm Drag to Back',
    type: 'Takedown',
    position: 'Standing',
    difficulty: 'Intermediate',
    description: 'A wrestling-based technique to take the back. Control the wrist and elbow, pull across your body, and circle to take the back.',
    keyPoints: [
      'Control wrist and elbow simultaneously',
      'Pull arm across body',
      'Step to the side and behind',
      'Keep head on the side'
    ],
    commonMistakes: [
      'Not controlling both wrist and elbow',
      'Pulling straight instead of across',
      'Poor footwork',
      'Not following to the back'
    ]
  },
  {
    id: 6,
    name: 'Triangle Choke',
    type: 'Submission',
    position: 'Guard',
    difficulty: 'Intermediate',
    description: 'A blood choke using your legs to create a triangle around the opponent\'s neck and arm. Control posture, create the angle, and squeeze with legs while pulling head down.',
    keyPoints: [
      'Break posture and control head',
      'Get proper leg positioning',
      'Create angle (don\'t finish straight on)',
      'Squeeze knees together and pull head'
    ],
    commonMistakes: [
      'Trying to finish without angle',
      'Not breaking posture first',
      'Wrong leg configuration',
      'Not controlling the arm'
    ]
  },
  {
    id: 7,
    name: 'Arm Bar',
    type: 'Submission',
    position: 'Guard',
    difficulty: 'Beginner',
    description: 'A fundamental joint lock attacking the elbow. Control the wrist, position your hips on the elbow, squeeze knees together, and extend hips to apply pressure.',
    keyPoints: [
      'Control the wrist with both hands',
      'Hips on elbow, not shoulder',
      'Squeeze knees together',
      'Lift hips to apply pressure'
    ],
    commonMistakes: [
      'Hips too high on arm',
      'Not controlling the wrist',
      'Knees not together',
      'Extending too fast'
    ]
  },
  {
    id: 8,
    name: 'Guillotine',
    type: 'Submission',
    position: 'Front Headlock',
    difficulty: 'Intermediate',
    description: 'A front choke submission. Secure the head and neck with your arm, lock hands, and apply pressure by lifting and squeezing.',
    keyPoints: [
      'Get arm deep around neck',
      'Keep elbows tight',
      'Use guard to prevent pass',
      'Lift and squeeze simultaneously'
    ],
    commonMistakes: [
      'Arm not deep enough',
      'Letting opponent pass guard',
      'Only squeezing without lifting',
      'Wrong hand grip'
    ]
  },
  {
    id: 9,
    name: 'Single Leg Takedown',
    type: 'Takedown',
    position: 'Standing',
    difficulty: 'Beginner',
    description: 'A fundamental wrestling takedown. Shoot in, secure one leg, and finish by driving through or lifting.',
    keyPoints: [
      'Change levels before shooting',
      'Secure leg high and tight',
      'Keep head on the side',
      'Drive through or lift to finish'
    ],
    commonMistakes: [
      'Not changing levels',
      'Grabbing leg too low',
      'Head in wrong position',
      'Not finishing the takedown'
    ]
  },
  {
    id: 10,
    name: 'Guard Pass',
    type: 'Guard Pass',
    position: 'Guard',
    difficulty: 'Intermediate',
    description: 'A fundamental technique to pass the opponent\'s guard. Control the legs, create pressure, and move to side control or mount.',
    keyPoints: [
      'Control hips and legs',
      'Maintain good posture',
      'Use pressure strategically',
      'Don\'t rush the pass'
    ],
    commonMistakes: [
      'Not controlling the hips',
      'Poor posture',
      'Rushing the pass',
      'Not securing the position'
    ]
  },
  {
    id: 11,
    name: 'Anaconda Choke',
    type: 'Submission',
    position: 'Front Headlock',
    difficulty: 'Advanced',
    description: 'A front headlock choke where you thread your arm under the opponent\'s neck and armpit, then lock your hands and apply pressure by walking sideways and rolling to finish.',
    keyPoints: [
      'Deep arm penetration under neck and armpit',
      'Lock hands securely with gable or S-grip',
      'Apply pressure by walking sideways and rolling',
      'Keep your head tight to their shoulder'
    ],
    commonMistakes: [
      'Shallow arm placement',
      'Failing to close the space between shoulder and neck',
      'Using only bicep strength, not body rotation',
      'Not committing to the roll'
    ]
  },
  {
    id: 12,
    name: 'Knee Slice Pass',
    type: 'Guard Pass',
    position: 'Guard',
    difficulty: 'Intermediate',
    description: 'A fundamental and effective guard pass where you slice your knee across the opponent\'s thigh while using frames to control distance and secure the underhook after passing.',
    keyPoints: [
      'Use forearm frame on the far hip',
      'Keep your head low and on the safe side',
      'Slide the knee tightly past their leg',
      'Secure the underhook immediately after passing'
    ],
    commonMistakes: [
      'Leaving the underhook exposed',
      'Standing up too high and getting swept',
      'Not controlling the distance with your frames',
      'Stopping halfway through the pass'
    ]
  },
  {
    id: 13,
    name: 'Ezekiel Choke',
    type: 'Submission',
    position: 'Mount',
    difficulty: 'Beginner',
    description: 'A sneaky choke applied from dominant positions like mount or side control. In No-Gi, use the blade of your wrist against the neck while applying rotational pressure with your body weight.',
    keyPoints: [
      'Apply choke with rotational pressure, not just a squeeze',
      'Keep your weight heavy on the opponent',
      'In No-Gi, use the blade of your wrist',
      'Thread the choking arm deep across the neck'
    ],
    commonMistakes: [
      'Telegraphing the choke by setting it up early',
      'Not maintaining top pressure, allowing escapes',
      'Using arms alone without body weight',
      'Incorrect wrist placement'
    ]
  },
  {
    id: 14,
    name: 'K-Guard Entry',
    type: 'Guard Retention',
    position: 'Guard',
    difficulty: 'Advanced',
    description: 'A modern guard used to off-balance the opponent and create entries for leg attacks or sweeps by trapping one of their legs with your own while controlling their upper body.',
    keyPoints: [
      'Control the opponent\'s sleeve on the trapped leg side',
      'Use your outside foot to hook behind their knee',
      'Use the entanglement to break their posture',
      'Stay active with constant pressure and movement'
    ],
    commonMistakes: [
      'Losing the sleeve grip',
      'Allowing the opponent to pressure forward and flatten you',
      'Poor foot placement leading to a weak hook',
      'Being static instead of dynamic'
    ]
  },
  {
    id: 15,
    name: 'Double Leg Takedown',
    type: 'Takedown',
    position: 'Standing',
    difficulty: 'Beginner',
    description: 'A fundamental wrestling takedown where you shoot in, grab both legs, and drive forward to take the opponent to the mat with power and control.',
    keyPoints: [
      'Level change with your head up',
      'Penetrate deep with your shot',
      'Drive through the opponent, not to the mat',
      'Keep your back straight during the lift/drive'
    ],
    commonMistakes: [
      'Shooting from too far away',
      'Dropping your head',
      'Stopping your momentum upon contact',
      'Not keeping hips low during entry'
    ]
  },
  {
    id: 16,
    name: 'Omoplata',
    type: 'Submission',
    position: 'Guard',
    difficulty: 'Intermediate',
    description: 'A shoulder lock submission applied from guard by swinging your leg over the opponent\'s shoulder and trapping their arm. Can be used as both a submission and a sweep.',
    keyPoints: [
      'Control the opponent\'s posture with your legs',
      'Pivot on your hip to create the angle for the lock',
      'Use the threat of the sweep to set up the submission',
      'Keep the trapped arm tight to your body'
    ],
    commonMistakes: [
      'Not controlling the far arm',
      'Failing to create the necessary angle',
      'Letting the opponent posture up and stack you',
      'Not committing to either the submission or sweep'
    ]
  },
  {
    id: 17,
    name: 'Half Guard Sweep (Old School)',
    type: 'Sweep',
    position: 'Half Guard',
    difficulty: 'Intermediate',
    description: 'From the bottom of half guard, you underhook the opponent\'s far leg and use a bridging motion to roll them over and come on top. A classic and highly effective sweep.',
    keyPoints: [
      'Secure a deep underhook on the top side',
      'Grab the far leg with your underhooking arm',
      'Use a bridging motion to create the sweep',
      'Keep your head on the mat side for leverage'
    ],
    commonMistakes: [
      'Not getting a deep enough underhook',
      'Trying to muscle the sweep instead of using leverage',
      'Forgetting to control the head',
      'Not timing the bridge with their weight shift'
    ]
  },
  {
    id: 18,
    name: 'Baseball Bat Choke',
    type: 'Submission',
    position: 'Side Control',
    difficulty: 'Intermediate',
    description: 'A powerful choke applied by gripping with both hands in a baseball bat grip and applying pressure to the sides of the neck, often from knee-on-belly or side control. Highly effective and sneaky.',
    keyPoints: [
      'Establish a strong cross-grip first',
      'Transition to knee-on-belly for optimal angle',
      'Apply pressure by driving your wrists forward and down',
      'Keep your weight distributed to prevent escape'
    ],
    commonMistakes: [
      'Gripping too high on the collar',
      'Not creating enough angle for the choke',
      'Losing the top position while setting it up',
      'Applying pressure too early before the grip is secure'
    ]
  },
  {
    id: 19,
    name: 'Berimbolo',
    type: 'Back Take',
    position: 'Guard',
    difficulty: 'Advanced',
    description: 'A dynamic, inversion-based technique used to take the opponent\'s back by spinning underneath them. Requires excellent flexibility, timing, and control. Modern sport jiu-jitsu staple.',
    keyPoints: [
      'Establish a strong grip on the opponent\'s pant leg or belt area',
      'Invert and use your hooks to off-balance and spin',
      'Always aim to secure both hooks for back control',
      'Control their hips throughout the rotation'
    ],
    commonMistakes: [
      'Inverting without controlling the opponent',
      'Losing the angle and ending up in a weak position',
      'Poor grip placement leading to a failed spin',
      'Not committing fully to the inversion'
    ]
  },
  {
    id: 20,
    name: 'Crucifix',
    type: 'Control',
    position: 'Back Control',
    difficulty: 'Intermediate',
    description: 'A dominant control position where you trap one of the opponent\'s arms and their head with your legs, leaving you free to attack with your arms. Excellent for setting up chokes and strikes.',
    keyPoints: [
      'Trap the arm and head tightly between your legs',
      'Use your free arms to secure the position and attack chokes',
      'Maintain constant pressure to prevent escapes',
      'Control the free hand to prevent defensive grips'
    ],
    commonMistakes: [
      'Loose leg control allowing the arm to escape',
      'Not controlling the opponent\'s free hand',
      'Giving up the position to hunt a submission prematurely',
      'Not maintaining back control pressure'
    ]
  },
  {
    id: 21,
    name: 'Toe Hold',
    type: 'Submission',
    position: 'Leg Entanglements',
    difficulty: 'Advanced',
    description: 'A leg lock submission that attacks the ankle by controlling the foot and applying rotational pressure. Requires good control and awareness of the opponent\'s position.',
    keyPoints: [
      'Control the leg to prevent escape',
      'Secure the foot with both hands',
      'Apply rotational pressure smoothly',
      'Maintain hip pressure throughout'
    ],
    commonMistakes: [
      'Not controlling the leg properly',
      'Applying pressure too quickly',
      'Poor grip on the foot',
      'Losing position during the attempt'
    ]
  },
  {
    id: 22,
    name: 'Cartwheel Pass',
    type: 'Guard Pass',
    position: 'Guard',
    difficulty: 'Advanced',
    description: 'An acrobatic guard pass that involves cartwheeling over the opponent\'s guard to achieve a dominant position. Requires athleticism and timing.',
    keyPoints: [
      'Control the far leg before initiating',
      'Maintain balance during the cartwheel',
      'Land in a stable position',
      'Immediately secure the position after landing'
    ],
    commonMistakes: [
      'Poor timing of the cartwheel',
      'Not controlling the leg properly',
      'Landing off-balance',
      'Not securing the position quickly'
    ]
  },
  {
    id: 23,
    name: 'Peruvian Necktie',
    type: 'Submission',
    position: 'Front Headlock',
    difficulty: 'Advanced',
    description: 'A unique choke from front headlock position that traps the opponent\'s arm and applies pressure to the neck. Effective against turtle position.',
    keyPoints: [
      'Secure the front headlock position',
      'Trap the arm properly',
      'Apply pressure with your body weight',
      'Roll to complete the choke'
    ],
    commonMistakes: [
      'Not trapping the arm securely',
      'Poor initial position',
      'Rushing the roll',
      'Not maintaining pressure throughout'
    ]
  },
  {
    id: 24,
    name: 'Spider Web',
    type: 'Control',
    position: 'Side Control',
    difficulty: 'Intermediate',
    description: 'A control position that isolates the opponent\'s arm and creates opportunities for armbars and other submissions from side control.',
    keyPoints: [
      'Isolate the arm completely',
      'Control the head',
      'Maintain pressure with your body',
      'Be ready to transition to submissions'
    ],
    commonMistakes: [
      'Not isolating the arm properly',
      'Losing head control',
      'Not maintaining pressure',
      'Missing submission opportunities'
    ]
  },
  {
    id: 25,
    name: 'Standing Guard Pass (Torreando)',
    type: 'Guard Pass',
    position: 'Guard',
    difficulty: 'Intermediate',
    description: 'A standing guard pass where you control the legs and toss them to one side while moving around to achieve side control.',
    keyPoints: [
      'Maintain good posture while standing',
      'Control both legs',
      'Move the legs decisively to one side',
      'Follow through to secure side control'
    ],
    commonMistakes: [
      'Poor posture while standing',
      'Not controlling the legs properly',
      'Hesitating during the pass',
      'Not securing the position after passing'
    ]
  },
  {
    id: 26,
    name: 'Loop Choke',
    type: 'Submission',
    position: 'Guard',
    difficulty: 'Intermediate',
    description: 'A sneaky choke from guard where you loop your arm around the opponent\'s neck and use their own collar to create the choke.',
    keyPoints: [
      'Get the grip deep',
      'Create the angle by moving your hips',
      'Use your other hand to assist',
      'Apply pressure gradually'
    ],
    commonMistakes: [
      'Shallow grip',
      'Not creating the proper angle',
      'Telegraphing the choke',
      'Applying pressure too quickly'
    ]
  },
  {
    id: 27,
    name: 'Sit-Up Sweep',
    type: 'Sweep',
    position: 'Guard',
    difficulty: 'Beginner',
    description: 'A fundamental sweep from closed guard where you sit up, control the opponent, and sweep them to the side.',
    keyPoints: [
      'Break posture first',
      'Sit up explosively',
      'Control the upper body',
      'Drive through the sweep'
    ],
    commonMistakes: [
      'Not breaking posture',
      'Sitting up too slowly',
      'Poor upper body control',
      'Not following through'
    ]
  },
  {
    id: 28,
    name: 'Gogoplata',
    type: 'Submission',
    position: 'Guard',
    difficulty: 'Advanced',
    description: 'An advanced choke using your shin across the opponent\'s throat while controlling their head. Requires flexibility and timing.',
    keyPoints: [
      'Get the shin positioned correctly',
      'Control the head',
      'Use your hands to assist the choke',
      'Maintain flexibility throughout'
    ],
    commonMistakes: [
      'Poor shin placement',
      'Not controlling the head properly',
      'Lack of flexibility',
      'Telegraphing the setup'
    ]
  },
  {
    id: 29,
    name: 'Leg Drag Pass',
    type: 'Guard Pass',
    position: 'Guard',
    difficulty: 'Intermediate',
    description: 'A guard pass where you drag the opponent\'s leg across their body while moving to the opposite side to achieve side control.',
    keyPoints: [
      'Control the leg properly',
      'Drag across the body',
      'Move to the opposite side',
      'Secure side control immediately'
    ],
    commonMistakes: [
      'Poor leg control',
      'Not moving to the side quickly enough',
      'Losing control during the pass',
      'Not securing the position'
    ]
  },
  {
    id: 30,
    name: 'Whizzer Kickover',
    type: 'Takedown',
    position: 'Standing',
    difficulty: 'Intermediate',
    description: 'A counter to a single leg takedown where you use an overhook (whizzer) and kick your leg over to take the opponent down.',
    keyPoints: [
      'Secure the overhook',
      'Maintain balance',
      'Kick the leg over explosively',
      'Follow through to secure the position'
    ],
    commonMistakes: [
      'Weak overhook',
      'Poor balance',
      'Not committing to the kick',
      'Not following through'
    ]
  },
  {
    id: 31,
    name: 'North-South Choke',
    type: 'Submission',
    position: 'North-South',
    difficulty: 'Intermediate',
    description: 'A choke from north-south position where you trap the opponent\'s arm and apply pressure to their neck with your arms.',
    keyPoints: [
      'Secure the north-south position',
      'Trap the arm properly',
      'Lock your hands correctly',
      'Apply pressure with your body weight'
    ],
    commonMistakes: [
      'Not trapping the arm',
      'Poor hand positioning',
      'Not using body weight',
      'Losing the position'
    ]
  },
  {
    id: 32,
    name: 'D\'Arce Choke',
    type: 'Submission',
    position: 'Front Headlock',
    difficulty: 'Advanced',
    description: 'A front headlock choke where you thread your arm under the opponent\'s neck and their own arm, then lock your hands and apply pressure.',
    keyPoints: [
      'Thread the arm deep',
      'Lock hands properly',
      'Use body weight to apply pressure',
      'Roll if necessary to finish'
    ],
    commonMistakes: [
      'Shallow arm placement',
      'Poor hand lock',
      'Not using body weight',
      'Not committing to the roll'
    ]
  },
  {
    id: 33,
    name: 'Americana',
    type: 'Submission',
    position: 'Mount',
    difficulty: 'Beginner',
    description: 'A fundamental shoulder lock submission from mount position. Isolate the arm, pin the wrist to the mat, and rotate the forearm towards the opponent\'s head to create pressure on the shoulder joint.',
    keyPoints: [
      'Maintain heavy mount pressure throughout',
      'Pin the wrist firmly to the mat',
      'Keep your elbow tight to your body',
      'Rotate the forearm smoothly, not forcefully',
      'Control the opponent\'s head with your free hand'
    ],
    commonMistakes: [
      'Rising up too high and losing mount',
      'Not pinning the wrist properly',
      'Using too much arm strength instead of body weight',
      'Cranking the submission too fast',
      'Not controlling the opponent\'s other arm'
    ]
  },
  {
    id: 34,
    name: 'Side Control Escape (Shrimp)',
    type: 'Escape',
    position: 'Side Control',
    difficulty: 'Beginner',
    description: 'The fundamental method to escape side control by creating space with your hips (shrimping) and inserting your knee to recover guard.',
    keyPoints: [
      'Frame on the neck and hip to prevent pressure',
      'Bridge explosively to create momentary space',
      'Shrimp your hips away while pushing the frames',
      'Insert bottom knee across the belt line to recover guard'
    ],
    commonMistakes: [
      'Pushing with arms instead of using frames',
      'Not bridging before shrimping',
      'Turning back flat to the mat too early',
      'Letting the opponent flatten you out'
    ]
  },
  {
    id: 35,
    name: 'Mount Escape (Bridge and Roll)',
    type: 'Escape',
    position: 'Mount',
    difficulty: 'Beginner',
    description: 'A classic mount escape (Upa) that capitalizes on the opponent\'s overcommitment by trapping an arm and leg on the same side and bridging powerfully.',
    keyPoints: [
      'Trap the opponent\'s arm securely against your chest',
      'Trap the foot on the same side so they cannot post',
      'Bridge hips high and at a 45-degree angle',
      'Look in the direction of the roll'
    ],
    commonMistakes: [
      'Bridging straight up instead of at an angle',
      'Not trapping the foot properly',
      'Using only arm strength to push',
      'Waiting too long to explode'
    ]
  },
  {
    id: 36,
    name: 'Back Control Escape (Shoulders to Mat)',
    type: 'Escape',
    position: 'Back Control',
    difficulty: 'Intermediate',
    description: 'Escaping back control by clearing the hooks, getting your back to the mat, and sliding your hips away from the opponent.',
    keyPoints: [
      'Protect your neck at all times with 2-on-1 control',
      'Fall to the "weak" side (underarm side)',
      'Bridge and push back to clear the hooks',
      'Get your shoulders and hips flat on the mat'
    ],
    commonMistakes: [
      'Ignoring the choke while fighting legs',
      'Falling to the "strong" side (choking arm side)',
      'Turning into the opponent before clearing hooks',
      'Leaving the neck exposed'
    ]
  },
  {
    id: 37,
    name: 'North-South Escape (Inversion)',
    type: 'Escape',
    position: 'North-South',
    difficulty: 'Advanced',
    description: 'Escaping the north-south position by creating space, framing on the hips, and inverting to recover guard.',
    keyPoints: [
      'Frame against the opponent\'s hips',
      'Create momentum by rocking legs',
      'Invert and place hooks on the opponent',
      'Spin underneath to recover guard'
    ],
    commonMistakes: [
      'Not framing properly',
      'Letting opponent control the head',
      'Lack of momentum',
      'Stopping halfway through the inversion'
    ]
  },
  {
    id: 38,
    name: 'Elbow Escape (Knee-to-Elbow)',
    type: 'Escape',
    position: 'Mount',
    difficulty: 'Beginner',
    description: 'Recovering guard from mount by creating space with frames and using the knee-to-elbow connection to pry a leg free.',
    keyPoints: [
      'Frame on the opponent\'s hips',
      'Turn on your side to create an angle',
      'Slide bottom knee along the mat to connect with elbow',
      'Capture the ankle to enter quarter/half guard'
    ],
    commonMistakes: [
      'Pushing the opponent\'s chest instead of hips',
      'Lying flat on back',
      'Lifting the knee too high',
      'Not protecting the neck'
    ]
  },
  {
    id: 39,
    name: 'Ninja Choke',
    type: 'Submission',
    position: 'Front Headlock',
    difficulty: 'Advanced',
    description: 'A powerful front choke applied from the front headlock or top position, often as a counter to a takedown or turtle. It involves threading one arm deep around the neck and locking it with the bicep of the other arm, similar to a rear naked choke but applied from the front.',
    keyPoints: [
      'Establish a deep grip around the neck, passing the chin',
      'Lock your hands using a figure-four (RNC) grip',
      'Use your chest to apply downward pressure on the back of the head',
      'Sprawl or step to the side to create the correct angle for the squeeze'
    ],
    commonMistakes: [
      'Applying the choke straight on without an angle',
      'Shallow arm placement that fails to clear the chin',
      'Squeezing with just the arms instead of using core and chest pressure',
      'Leaving the opponent too much space to roll or escape'
    ]
  }
];